import imgSpinner from  "../assets/spinner.png"
import "./spinner.scss"

const Spinner = props => {
    return <div className="spinner"><img src={ imgSpinner } alt="Loading spinner"/></div>
}

export default Spinner